import { render, staticRenderFns } from "./IssueDetails.vue?vue&type=template&id=6fbaf828&scoped=true&"
import script from "./IssueDetails.vue?vue&type=script&lang=ts&"
export * from "./IssueDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbaf828",
  null
  
)

export default component.exports